// Model.jsx
import React, { useEffect, useRef } from 'react';

const ModelParagraph = ({ onClose, title, message }) => {
    const modalRef = useRef(null);

    const handleOutsideClick = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            onClose();
        }
    };

    useEffect(() => {
        document.body.style.overflow = 'hidden'; // Disable scrolling on the body when the modal is open
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.body.style.overflow = 'auto'; // Re-enable scrolling on the body when the modal is closed
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    return (
        <div>
            <div className="modal-overlay"></div>

            <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
                <div className="modal-dialog modal-dialog-centered p-3 py-5" ref={modalRef}>
                    <div className="modal-content">
                        <div className="container d-flex flex-column p-4">
                            <span className="fw-bold h6 text-pink mb-2">TeamLewis</span>

                            <span className="fs-1 text-white mb-3">
                                {title}
                            </span>

                            <span className="h5 text-white text-justify"
                                dangerouslySetInnerHTML={{
                                    __html: message,
                                }}>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModelParagraph;
